import React from "react";
import locale from "antd/es/date-picker/locale/ru_RU";
import { DatePicker, Space } from "antd";
import "./index.scss";
import * as M from "moment";
import { observer } from "mobx-react-lite";
const { RangePicker } = DatePicker;
export const DatePickerComponentAnalytics = observer(
  ({ onChange, store }): React.FC => {
    const [picker, setPicker] = React.useState(true);

    const handlerOnChange = (e) => {
      M(e, "DD.MM.YYYY").set({
        h: 17,
        m: 17,
      });
      onChange(e);
      setPicker(true);
    };
    return (
      <div className="change_placeholder olddatepicker">
        {picker && <span className="start_date">Начальная дата</span>}
        {picker && <span className="end_date">Конечная дата</span>}
        <RangePicker
          value={[
            store?.DateFrom
              ? M(store?.DateFrom, "DD.MM.YYYY").set({
                  h: 17,
                  m: 17,
                })
              : undefined,
            store?.DateTo
              ? M(store?.DateTo, "DD.MM.YYYY").set({
                  h: 17,
                  m: 17,
                })
              : undefined,
          ]}
          className={"range-picker"}
          locale={locale}
          format="DD.MM.YYYY"
          onChange={handlerOnChange}
          onKeyDown={(event: React.KeyboardEvent<HTMLInputElement>) => {
            const key = event.key;
            if (key === "Backspace" || key === "Delete") {
              return;
            }
            const input = event.target as HTMLInputElement;
            const curValue = input.value;
  
            if (curValue.length === 10) {
              event.preventDefault();
              return;
            }
  
            if (key < "0" || key > "9") {
              event.preventDefault();
              return;
            }
  
            let newValue = "";
            switch (curValue.length) {
              case 2:
              case 5:
                newValue = curValue + ".";
                break;
              default:
                newValue = curValue;
            }
  
            input.value = newValue;
          }}
        />
      </div>
    );
  },
);
